import React from 'react';
import figlet from 'figlet';
import font from 'figlet/importable-fonts/Hollywood';
import {getDebug} from '../library/GeneralUse';

const style = {
	asciiContainer: `flex justify-center   text-[0.4rem] recommended:text-xs font-black text-right`,
	asciiText: `text-left`,
};

const DEBUG = getDebug('misc');

export const ASCIIArt = ({dataTestId, tailwindcss, text}) => {
	let asciiArt;

	figlet.parseFont('Hollywood', font);
	figlet.text(
		text,
		{
			font: 'Hollywood',
			horizontalLayout: 'fitted',
		},
		(error, output) => {
			if (error) {
				DEBUG && console.error(error);
			} else {
				asciiArt = output.trimEnd();
			}
		},
	);

	return (
		<pre className={`${style.asciiContainer} ${tailwindcss}`}>
			<span
				className={style.asciiText}
				data-test-id={`${dataTestId}ASCIIArt_TEST`}
				data-test-text={text}>
				{asciiArt}
			</span>
		</pre>
	);
};
